var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGovernanceBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 331,
    viewBox: "0 0 331 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.85 262.322V305.09C328.85 318.212 318.212 328.85 305.09 328.85H251.63",
    stroke: "#5D00FF",
    strokeWidth: 3.564
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1511 68.6782V25.9102C2.1511 12.788 12.7888 2.15023 25.9111 2.15023H79.3711",
    stroke: "#5D00FF",
    strokeWidth: 3.564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernanceBg);
export default __webpack_public_path__ + "static/media/GovernanceBg.cbe2d4907926af396100738c40bac8a8.svg";
export { ForwardRef as ReactComponent };